import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import AccessRequestItem from "../Components/AccessRequestItem/AccessRequestItem";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function AccessRequestUser() {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    const fetchRequests = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/requests`,
          {
            credentials: "include",
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || t("error_occurred"));
        }

        setRequests(data.requests);
      } catch (err) {
        setError(err.message || t("error_occurred"));
      }
    };

    fetchRequests();
  }, []);

  return (
    <Container>
      {error && <p className="text-danger">{error}</p>}
      {requests.length === 0 ? (
        <p className="text-center">{t("no_access_requests")}</p>
      ) : (
        requests.map((request) => (
          <AccessRequestItem
            student={true}
            key={request._id}
            request={request}
          />
        ))
      )}
    </Container>
  );
}

export default AccessRequestUser;
